(function () {

    angular
        .module('smartertoolsApp')
        .service('hostingService', ['$http', 'refreshToken', '$log', 'cacheControl', '$q', hostingService]);

    function hostingService($http, refreshToken, $log, cacheControl, $q) {
        let getAllPromise;
        const vm = this;
        vm.urlBase = apiRootUrl;

        // Functions
        vm.getServices = getServices;
        vm.getAdminUsers = getAdminUsers;
        vm.resetAdminPassword = resetAdminPassword;
        vm.endTrial = endTrial;
        vm.subscribeExistingCard = subscribeExistingCard;
        vm.subscribeNewCard = subscribeNewCard;
        vm.clearServiceCache = clearServiceCache;
        vm.saveAdvancedOptions = saveAdvancedOptions;
        vm.cancelSite = cancelSite;
        vm.setBindings = setBindings;
        vm.savePaymentMethodExistingCard = savePaymentMethodExistingCard;
        vm.savePaymentMethodNewCard = savePaymentMethodNewCard;
        vm.savePaymentMethodNoCard = savePaymentMethodNoCard;
        vm.calculatePriceChangeForUpgrade = calculatePriceChangeForUpgrade;
        vm.changePlan = changePlan;
        vm.resubscribeBeforeCancel = resubscribeBeforeCancel;

        activate();

        // -----------------------------------------------

        function activate() {
        }

        function getServices() {
            //if (getAllPromise)
            //    return getAllPromise;
            getAllPromise = refreshToken.refreshToken()
                .then(() => $http.get(vm.urlBase + 'v1/account/hosted-services/all'))
                .then(function (response) {
                    getAllPromise = null;
                    return response.data;
                })
                .catch(function (err) {
                    getAllPromise = null;
                    $q.reject(err);
                });
            return getAllPromise;
        }

        function clearServiceCache() {
            cacheControl.getCache('invoiceCache')
                .remove(vm.urlBase + 'v1/account/hosted-services/all');
        }

        function getAdminUsers(siteId) {
            return refreshToken.refreshToken()
                .then(() => $http.get(`${vm.urlBase}v1/account/hosted-services/${siteId}/site-admins`))
                .then((response) => response.data.Admins);
        }

        function calculatePriceChangeForUpgrade(siteId, agents) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/calculate-upgrade-cost`, JSON.stringify({NewUserCount: agents})))
                .then((response) => response.data);
        }

        function changePlan(siteId, agents) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/change-plan`, JSON.stringify({NewUserCount: agents})))
                .then((response) => response.data);
        }

        function resubscribeBeforeCancel(siteId) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/resubscribe-before-cancel`))
                .then((response) => response.data);
        }

        function resetAdminPassword(siteId, userId, newPassword) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/reset-admin-pw`, JSON.stringify({
                    UserId: userId,
                    NewPassword: newPassword
                })))
                .then((response) => response.data);
        }

        function saveAdvancedOptions(siteId, options) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/advanced-options`, JSON.stringify(options)))
                .then((response) => response.data);
        }

        function setBindings(siteId, options) {
            const bindings = options.split('\n');
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/bindings`, JSON.stringify({Bindings: bindings})))
                .then((response) => response.data);
        }


        function endTrial(siteId) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/end-trial`))
                .then((response) => response.data);
        }

        function cancelSite(siteId) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${siteId}/cancel-site`))
                .then((response) => response.data);
        }

        function subscribeExistingCard(serviceId, agentCount, paymentMethod) {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.post(`${vm.urlBase}v1/account/hosted-services/${serviceId}/subscribe-existing-card`,
                        JSON.stringify({
                            AgentCount: agentCount,
                            PaymentMethodId: paymentMethod.PaymentMethodId,
                            SecurityCode: paymentMethod.SecurityCode
                        }));
                })
                .then((response) => response.data);
        }

        function subscribeNewCard(serviceId, agentCount, paymentMethod) {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.post(`${vm.urlBase}v1/account/hosted-services/${serviceId}/subscribe-new-card`,
                        JSON.stringify({
                            AgentCount: agentCount,
                            CardNumber: paymentMethod.CardNumber,
                            NameOnCard: paymentMethod.NameOnCard,
                            ExpirationMonth: paymentMethod.ExpirationMonth,
                            ExpirationYear: paymentMethod.ExpirationYear,
                            SecurityCode: paymentMethod.SecurityCode,
                            Country: paymentMethod.Country,
                            Address1: paymentMethod.Address1,
                            Address2: paymentMethod.Address2,
                            City: paymentMethod.City,
                            State: paymentMethod.State,
                            ZipCode: paymentMethod.ZipCode,
                            SaveCard: true
                        }));
                })
                .then((response) => response.data);
        }

        function savePaymentMethodExistingCard(serviceId, paymentMethod) {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.post(`${vm.urlBase}v1/account/hosted-services/${serviceId}/payment-method-existing-card`,
                        JSON.stringify({
                            PaymentMethodId: paymentMethod.PaymentMethodId,
                            SecurityCode: paymentMethod.SecurityCode
                        }));
                })
                .then((response) => response.data);
        }

        function savePaymentMethodNoCard(serviceId) {
            return refreshToken.refreshToken()
                .then(() => $http.post(`${vm.urlBase}v1/account/hosted-services/${serviceId}/payment-method-no-card`, JSON.stringify({})))
                .then((response) => response.data);
        }

        function savePaymentMethodNewCard(serviceId, paymentMethod) {
            return refreshToken.refreshToken()
                .then(function () {
                    return $http.post(`${vm.urlBase}v1/account/hosted-services/${serviceId}/payment-method-new-card`,
                        JSON.stringify({
                            CardNumber: paymentMethod.CardNumber,
                            NameOnCard: paymentMethod.NameOnCard,
                            ExpirationMonth: paymentMethod.ExpirationMonth,
                            ExpirationYear: paymentMethod.ExpirationYear,
                            Country: paymentMethod.Country,
                            Address1: paymentMethod.Address1,
                            Address2: paymentMethod.Address2,
                            City: paymentMethod.City,
                            State: paymentMethod.State,
                            ZipCode: paymentMethod.ZipCode
                        }));
                })
                .then((response) => response.data);
        }
    }
})();
